import {Route, Switch} from "react-router";
import '../App/App.scss'
import * as React from "react";
import connectRoute from "./connectRoute";
import {
  ErrorPage,
  PostshopLocatorPage,
} from "./external";
import {get} from 'lodash';

declare global {
  interface Window {
    __NZPOST_REACT_PKL__: {
      baseUrl: string;
      locationName?: string;
      locationIdAndName?: string
    }
  }
}

//we expect drupal to let the app know where has PKL been configured to work
//if it's undefined, we fallback on using the index / as the base url
let baseUrl = get(window, '__NZPOST_REACT_PKL__.baseUrl') ? window.__NZPOST_REACT_PKL__.baseUrl:'/';
//in case the user entered a baseUrl not ending with / with need to add it
if (!baseUrl.endsWith('/')) {
  baseUrl += '/';
}

export const paths = {
  POSTSHOP_LOCATOR_INDEX: `${baseUrl}`,
  POSTSHOP_LOCATOR: `${baseUrl}:locationName`,
  POSTSHOP_LOCATOR_DETAIL: `${baseUrl}location/:locationIdAndName`,
  SERVER_ERROR: `${baseUrl}oops`
};

// parcel for you functions for user journey flow

/**
 * Default routes
 * IMPORTANT: Please wrap all your page in connectRoute which will add a few common functionalities such as:
 * - Stop Switch from rendering the component on deprecated stage componentWillReceiveProps
 * - Scroll window to top of the page
 *]
 * @author MaxT
 * @author NickT
 */

const routes =
  <Switch>
    <Route exact path={paths.SERVER_ERROR} component={connectRoute(ErrorPage)}/>
    <Route exact path={paths.POSTSHOP_LOCATOR_INDEX} component={connectRoute(PostshopLocatorPage)}/>
    <Route exact path={paths.POSTSHOP_LOCATOR_DETAIL} component={connectRoute(PostshopLocatorPage)}/>
    <Route exact path={paths.POSTSHOP_LOCATOR} component={connectRoute(PostshopLocatorPage)}/>
  </Switch>
;

export {
  baseUrl
}

export default routes;


// WEBPACK FOOTER //
// ./src/routes/routes.tsx